import { ApplicationEventNotificationTemplateType } from "gen/clients";

export function describeNotificationTemplateType(type: ApplicationEventNotificationTemplateType): string {
  switch (type) {
    case ApplicationEventNotificationTemplateType.INTERNAL:
      return "Internal";
    case ApplicationEventNotificationTemplateType.CLIENT:
      return "Client";
    default:
      return type;
  }
}

export const notificationTemplateTypeOptions = Object.values(ApplicationEventNotificationTemplateType).map(type => ({
  label: describeNotificationTemplateType(type),
  value: type
}));
